import SharedReactTable from "components/shared/reactTable";
import { ProvideScrollPosition } from "contexts/scrollPosition";
import { dateTimeToView } from "helpers/date";
import { paths } from "helpers/paths";
import { DateColumnFilter, rowIndexColumn } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import React, { useMemo } from "react";
import { Link } from "react-router-dom";

function CounterpartyAddresses(props) {
    const tableColumns = useMemo(() => {
        return [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Название",
                accessor: "name",
                filterable: true,
                Cell: ({
                    value,
                    row: {
                        original: { id },
                    },
                }) => <Link to={paths.counterpartyPointShow(props.counterpartyId, id)}>{value}</Link>,
            },
            {
                Header: "Клиент",
                accessor: "client",
                filterable: true,
            },
            {
                Header: "Адрес",
                accessor: "geozone",
                id: "geozone/address",
                filterable: true,
                sortKey: "geozone/address",
                Cell: ({ value }) => value.address,
            },
            {
                Header: "Дата последнего использования",
                accessor: "lastUsedAt",
                sortable: true,
                filterable: true,
                filterType: "date",
                Filter: DateColumnFilter,
                Cell: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss"),
                CSVExport: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss"),
            },
            {
                Header: "",
                accessor: "action",
                sortable: false,
                notExportable: true,
                Cell: ({ row }) => (
                    <div
                        className="btn btn-xs btn-outline-primary"
                        onClick={() => {
                            props.onChange({ name: "geozone", value: row.original });
                            props.back();
                        }}
                    >
                        Выбрать
                    </div>
                ),
            },
        ];
    }, []);

    return (
        <ProvideScrollPosition>
            <SharedReactTable
                {...props}
                isNotExportable
                wrapCname="flex-1"
                getList={(params) => props.getList({ ...params, counterpartyId: props.counterpartyId })}
                columns={tableColumns}
            />
        </ProvideScrollPosition>
    );
}

export default tableContainer(CounterpartyAddresses, "counterpartypoints");
